function checkLive(player) {
	const hls = player.hls_;
	const hlsLevel = hls && hls.levels && hls.levels[hls.currentLevel];
	const isLive = hlsLevel && hlsLevel.details && hlsLevel.details.live;
	return isLive;
}

export { checkLive };
